define('shared/util/dispatchers/retrievers/cookie',['shared/lib/RSVP', 'shared/lib/cookie'], function( RSVP, cookie ){
    'use strict';
    
    return function ( key ) {
        return new RSVP.Promise(function(resolve, reject){
            resolve( cookie.get( key ) );
        });
    };
});

